import { CommercialType } from './commercial-types';

/**
 * Role Performer Types - Subset needed for ClassifierService
 */
export enum RolePerformerType {
  OnCameraPrincipal = 'On Camera Principal',
  OffCameraPrincipal = 'Off Camera Principal',
  Extra = 'Extra',
  Radio = 'Radio',
  AFM = 'American Federation Of Musicians',
  OnCameraGroup = 'On Camera Group',
  OnCameraGroupContractor = 'On Camera Group Contractor (1-2)',
  OnCameraGroupContractor3To5 = 'On Camera Group Contractor (3-5)',
  OnCameraGroupContractor6To8 = 'On Camera Group Contractor (6-8)',
  OnCameraGroupContractor9Plus = 'On Camera Group Contractor (9+)',
  OffCameraGroup = 'Off Camera Group',
  OffCameraGroupContractor = 'Off Camera Group Contractor (1-2)',
  OffCameraGroupContractor3To5 = 'Off Camera Group Contractor (3-5)',
  OffCameraGroupContractor6To8 = 'Off Camera Group Contractor (6-8)',
  OffCameraGroupContractor9Plus = 'Off Camera Group Contractor (9+)',
}

export enum RolePerformerClassification {
  OnCamera = 'on_camera',
  OffCamera = 'off_camera',
}

// from web/roleTypes - only one being used
export const GroupPerformerTypes = [
  RolePerformerType.OnCameraGroup,
  RolePerformerType.OffCameraGroup,
];

export const GroupPerformerTypeFilter = [
  RolePerformerType.OnCameraGroupContractor,
  RolePerformerType.OnCameraGroupContractor3To5,
  RolePerformerType.OnCameraGroupContractor6To8,
  RolePerformerType.OnCameraGroupContractor9Plus,
  RolePerformerType.OffCameraGroupContractor,
  RolePerformerType.OffCameraGroupContractor3To5,
  RolePerformerType.OffCameraGroupContractor6To8,
  RolePerformerType.OffCameraGroupContractor9Plus,
];

/**
 * Role Performer Types by Commercial
 */
export const CommercialPerformerTypes: Record<string, RolePerformerType[]> = {
  [CommercialType.TV]: [
    RolePerformerType.OnCameraPrincipal,
    RolePerformerType.OnCameraGroup,
    RolePerformerType.OffCameraPrincipal,
    RolePerformerType.OffCameraGroup,
    RolePerformerType.Extra,
    RolePerformerType.AFM,
  ],
  [CommercialType.Radio]: [RolePerformerType.Radio, RolePerformerType.AFM],
};
